// Vendor
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
// NgRx reducers
import { getLogger } from 'NewAngular/state/logger';
// Module imports
import { ConfigModule } from 'NewAngular/config/config.module';
import { NavigationModule } from 'NewAngular/features/components/navigation/navigation.module';
import { SecurityHeaderControlModule } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.module';
import { SymbolSwitcherModule } from 'SecuritiesApp/ts/features/symbol-switcher/symbol-switcher.module';
import { SideMenuModule } from 'NewAngular/features/components/side-menu/side-menu.module';
// Components
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'NewAngular/features/components/side-menu/side-menu.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class BaseSecurityPageModule {
}
BaseSecurityPageModule.ɵfac = function BaseSecurityPageModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BaseSecurityPageModule)(); };
BaseSecurityPageModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: BaseSecurityPageModule, bootstrap: [TopBarNavComponent, SideMenuComponent, SecurityHeaderControlComponent] });
BaseSecurityPageModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        ConfigModule,
        NavigationModule,
        SecurityHeaderControlModule,
        SymbolSwitcherModule,
        SideMenuModule,
        StoreModule.forRoot({}, { metaReducers: getLogger() })] });
